import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { LiteralsState } from '../../reducers/literals.reducer';
import * as selectors from '../../selectors/literals/paginator.literals.selectors';

@Injectable({
  providedIn: 'root',
})
export class PaginatorLiteralsFacadeService extends FacadeService {
  constructor(public override store: Store<LiteralsState>) {
    super(store);
  }

  // OBSERVABLES
  orderDesc$ = this.storeSelect(selectors.getOrderDesc);
  orderAsc$ = this.storeSelect(selectors.getOrderAsc);
  creationDate$ = this.storeSelect(selectors.getCreationDate);
  items$ = this.storeSelect(selectors.getItems);
  sortField$ = this.storeSelect(selectors.getSortField);
  order$ = this.storeSelect(selectors.getOrder);
  userUserName$ = this.storeSelect(selectors.getUserUserName);
  userDisplayedName$ = this.storeSelect(selectors.getUserDisplayedName);
  userEmail$ = this.storeSelect(selectors.getUserEmail);
  storeCreationDate$ = this.storeSelect(selectors.getStoreCreationDate);
  storeCode$ = this.storeSelect(selectors.getStoreCode);

  // OBSERVABLE'S VALUES
  get orderDesc() {
    return this.storeSnapshot(this.orderDesc$);
  }

  get orderAsc() {
    return this.storeSnapshot(this.orderAsc$);
  }

  get creationDate() {
    return this.storeSnapshot(this.creationDate$);
  }

  get userUserName() {
    return this.storeSnapshot(this.userUserName$);
  }

  get userDisplayedName() {
    return this.storeSnapshot(this.userDisplayedName$);
  }

  get userEmail() {
    return this.storeSnapshot(this.userEmail$);
  }

  get storeCreationDate() {
    return this.storeSnapshot(this.storeCreationDate$);
  }

  get storeCode() {
    return this.storeSnapshot(this.storeCode$);
  }
}
